import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    VForm,
    {
      ref: "addressSelectForm",
      staticClass: "validator-form",
      attrs: { id: "gav", name: "gavForm" },
      model: {
        value: _vm.formValid,
        callback: function ($$v) {
          _vm.formValid = $$v
        },
        expression: "formValid",
      },
    },
    [
      _c("h1", { staticClass: "heading" }, [
        _vm._v(
          "\n        " + _vm._s(_vm.translate("gav.addressSelect")) + "\n    "
        ),
      ]),
      _vm._v(" "),
      _c(
        "h2",
        { staticClass: "alert-line" },
        [
          _c("ns-icon", {
            staticStyle: { width: "1.5em", height: "1.5em" },
            attrs: { "icon-name": "icon-error-color-filled", color: "#B2140A" },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "ml-2" }, [
            _vm._v(_vm._s(_vm.translate("gav.validationAlert"))),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("p", { staticClass: "address-verification-context" }, [
        _vm._v(
          "\n        " +
            _vm._s(_vm.translate("gav.addressVerificationContext")) +
            "\n    "
        ),
      ]),
      _vm._v(" "),
      _c(VDivider, { staticClass: "divider-1" }),
      _vm._v(" "),
      _c("div", { staticClass: "original-address-container" }, [
        Array.isArray(_vm.suggestedAddresses) &&
        _vm.suggestedAddresses.length >= 0
          ? _c(
              "div",
              { staticClass: "font-weight-regular radio-buttons" },
              [
                _c(
                  VRadioGroup,
                  {
                    model: {
                      value: _vm.selectedAddress,
                      callback: function ($$v) {
                        _vm.selectedAddress = $$v
                      },
                      expression: "selectedAddress",
                    },
                  },
                  [
                    _c(VRadio, {
                      attrs: {
                        value: _vm.normalizedAddress,
                        "data-testid": "originalAddress",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "label",
                            fn: function () {
                              return [
                                _c("div", [
                                  _vm._v(_vm._s(_vm.translate("gav.original"))),
                                ]),
                                _vm._v(" "),
                                _c("formatted-address", {
                                  attrs: { address: _vm.normalizedAddress },
                                }),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        2007556847
                      ),
                    }),
                    _vm._v(" "),
                    Array.isArray(_vm.suggestedAddresses) &&
                    _vm.suggestedAddresses.length > 0
                      ? _c(VRadio, {
                          attrs: {
                            value: _vm.suggestedAddresses[0],
                            "data-testid": "firstSuggestedAddress",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "label",
                                fn: function () {
                                  return [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(_vm.translate("gav.suggested"))
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("formatted-address", {
                                      attrs: {
                                        address: _vm.suggestedAddresses[0],
                                      },
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            3145474711
                          ),
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    Array.isArray(_vm.suggestedAddresses) &&
                    _vm.suggestedAddresses.length > 1
                      ? _c(
                          "div",
                          { staticClass: "additional-address-suggestions" },
                          [
                            _c("div", [
                              _vm._v(
                                _vm._s(_vm.translate("gav.alsoSuggested"))
                              ),
                            ]),
                            _vm._v(" "),
                            _vm._l(
                              _vm.suggestedAddresses.slice(1),
                              function (item, i) {
                                return _c(
                                  "div",
                                  { key: i },
                                  [
                                    _c(VRadio, {
                                      attrs: {
                                        value: item,
                                        "data-testid": "selectedAddress",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "label",
                                            fn: function () {
                                              return [
                                                _c("formatted-address", {
                                                  attrs: { address: item },
                                                }),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                )
                              }
                            ),
                          ],
                          2
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.partialType,
                expression: "!partialType",
              },
            ],
            staticClass: "button-container",
          },
          [
            _c(
              "button",
              {
                staticClass: "cancel-button link",
                attrs: { "data-testid": "cancelButton" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return function () {
                      _vm.addressClose()
                      _vm.selectedAddress = null
                    }.apply(null, arguments)
                  },
                },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.translate("gav.cancel")) +
                    "\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "primary-solid",
                attrs: {
                  "data-testid": "confirmAddress",
                  disabled: !this.selectedAddress,
                },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.confirmSelectedAddress.apply(null, arguments)
                  },
                },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.translate("gav.confirmAddress")) +
                    "\n            "
                ),
              ]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      Array.isArray(_vm.suggestedAddresses) && _vm.suggestedAddresses.length < 1
        ? _c("div", { staticClass: "font-weight-regular" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.translate("gav.noSuggestionsFound")) +
                "\n    "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.partialType
        ? _c(
            "div",
            [
              _c("partial-selection", {
                attrs: {
                  error: _vm.partialSubmitted && _vm.partialError,
                  translations: _vm.partialSelectionText,
                  partialSuggestions: _vm.partialSuggestions,
                },
                on: {
                  "clear-error": _vm.clearPartialError,
                  "partial-address-selected": _vm.onPartialAddressSelected,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.busy
        ? _c(
            "div",
            {
              staticClass: "spinner-container",
              attrs: { "data-testid": "busySpinner" },
            },
            [_c("NsSpinner", { staticClass: "spinner" })],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }